import React, {useEffect, useRef, useState} from "react";

import SummaryHeader from "../../summary/atoms/SummaryHeader";
import SummaryContainer from "../../summary/organisms/SummaryContainer";
import {useSelector} from "react-redux";



const MediaWallSummary = ({summaryData}) => {

  const bodyRef = useRef(null);
  const innerRef = useRef();
  const currentHeader = useSelector(state => state.optionWindow.currentHeader);
  const offsetTopList = useSelector(state => state.summary.offsetTopList);
  const remoteScrollData = useSelector(state => state.summary.remoteScrollData);



  const [headerOpacity, setHeaderOpacity] = useState(false);



  const scrollHandle = () => {
    if (bodyRef.current.scrollTop >= innerRef.current.offsetTop) {
      setHeaderOpacity(true);
    } else {
      setHeaderOpacity(false);
    }
  }


  const [indexState, setIndexState] = useState();

  useEffect(() => {
    if(!remoteScrollData) {
      return ;
    }
    bodyRef.current.style.scrollBehavior = "smooth";
    if(remoteScrollData.currentScrollIndex !== -1){
      setIndexState(remoteScrollData.currentScrollIndex);
    } else {
      setIndexState(indexState);
    }
  },[remoteScrollData]);


  useEffect(() => {
    if(!remoteScrollData) {
      return ;
    }
    bodyRef.current.scrollTop = offsetTopList[indexState]/ remoteScrollData.offsetTopList[indexState] * remoteScrollData.currentScrollTop;
    bodyRef && bodyRef.current && bodyRef.current.addEventListener("scroll", scrollHandle);

    return () => {
      bodyRef && bodyRef.current && bodyRef.current.removeEventListener("scroll", scrollHandle);
    }
  },[remoteScrollData, indexState]);




  return (
    <div className={`summary ${currentHeader.includes("summary") ? "active" : ""}`}>
      <SummaryHeader headerOpacity={headerOpacity}/>
      <SummaryContainer bodyRef={bodyRef} innerRef={innerRef} summaryData={summaryData} />
    </div>)
}
export default MediaWallSummary
